import styled from 'styled-components'

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import { LpVaultsListContainer } from './components/LpVaultsListContainer'
import { usePostHogEntityViewed } from 'utils/usePostHogEntityViewed'
import { GLOBAL_BANNER_HEIGHT } from 'components/GlobalBanner/GlobalBanner'
import { useGlobalBanner } from 'utils/useGlobalBanner'

const Page = styled.div<{ $hasBanner: boolean }>`
  min-height: calc(100vh - 462px);
  margin-top: calc(124px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-top: calc(100px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

    & > nav {
      padding: 0 20px;
    }

    // & > div {
    //   margin-top: -40px;
    // }
  }
`

export const LpVaultsContainer = () => {
  const { isEnabled: hasBanner } = useGlobalBanner()

  usePostHogEntityViewed('lp:list_view')

  return (
    <Page $hasBanner={hasBanner}>
      <Breadcrumbs
        items={[
          { label: 'Home', path: '/' },
          { label: 'LP Vaults', path: '/lp-vaults' },
        ]}
      />
      <LpVaultsListContainer />
    </Page>
  )
}
